/**
 * Logikk for Work Environment Alert System
 * Håndterer triggere, varslingstyper og anbefalte tiltak.
 */

export const ALERT_THRESHOLDS = {
  WE_SCORE_DROP: 10,
  STRESS_LIMIT: 70,
  CONFLICT_LIMIT: 70,
  SAFETY_FLOOR: 40
};

export const getAlertsFromData = (current, previous) => {
  const alerts = [];

  // Drop in WE Score
  if (previous.weScore - current.weScore >= ALERT_THRESHOLDS.WE_SCORE_DROP) {
    alerts.push({
      id: 'we-drop',
      type: 'Dashboard',
      trigger: 'WE Score Fall',
      message: 'Arbeidsmiljøscore har falt med over 10 poeng siden forrige måling.',
      severity: 'Critical',
      recommendations: ['Conduct team workshop', 'Leadership review'],
      icon: 'TrendingDown'
    });
  }

  // High Stress
  if (current.stress > ALERT_THRESHOLDS.STRESS_LIMIT) {
    alerts.push({
      id: 'high-stress',
      type: 'Email & Dashboard',
      trigger: 'Kritisk Stress',
      message: 'Stress-indeksen er over 70. Risiko for sykemeldinger er betydelig.',
      severity: 'Critical',
      recommendations: ['Leadership review', 'Resource allocation audit'],
      icon: 'Wind'
    });
  }

  // High Conflict
  if (current.conflict > ALERT_THRESHOLDS.CONFLICT_LIMIT) {
    alerts.push({
      id: 'high-conflict',
      type: 'Consultant & Dashboard',
      trigger: 'Konfliktrisiko',
      message: 'Konfliktnivået har passert kritisk grense (70+).',
      severity: 'High',
      recommendations: ['Conflict mediation', 'Individual de-briefs'],
      icon: 'AlertTriangle'
    });
  }

  // Low Safety
  if (current.safety < ALERT_THRESHOLDS.SAFETY_FLOOR) {
    alerts.push({
      id: 'low-safety',
      type: 'Dashboard',
      trigger: 'Lav Trygghet',
      message: 'Psykologisk trygghet er under kritisk nivå (40). Taushetskultur detektert.',
      severity: 'Critical',
      recommendations: ['Conduct team workshop', 'Psychological safety training'],
      icon: 'ShieldOff'
    });
  }

  return alerts;
};

export const mockCurrentData = {
  weScore: 52,
  stress: 78,
  conflict: 45,
  safety: 35
};

export const mockPreviousData = {
  weScore: 65,
  stress: 62,
  conflict: 40,
  safety: 48
};